export const userEntitiesData = {
    data: [
        {
            'name':     'Client',
            'readonly': false,
            'create':   true,
            'edit':     true,
            'delete':   false,
        },
        {
            'name':     'Site',
            'readonly': true,
            'create':   true,
            'edit':     false,
            'delete':   false,
        },
        {
            'name':     'Equipment',
            'readonly': false,
            'create':   false,
            'edit':     true,
            'delete':   true,
        },
        {
            'name':     'Sensor',
            'readonly': true,
            'create':   true,
            'edit':     false,
            'delete':   false,
        },
        {
            'name':     'Service Management',
            'readonly': false,
            'create':   true,
            'edit':     false,
            'delete':   false,
        },
        {
            'name':     'Service Management',
            'readonly': false,
            'create':   true,
            'edit':     false,
            'delete':   true,
        },
        {
            'name':     'Notification',
            'readonly': true,
            'create':   true,
            'edit':     true,
            'delete':   false,
        }
    ]
};
